"use client";

import {
	DEFAULT_CASH_DEPOSIT,
	DEFAULT_INTEREST_RATE,
	DEFAULT_INVOICE_FEE,
	DEFAULT_MONTHS,
	DEFAULT_SALVAGE_AMOUNT,
	DEFAULT_SETUP_FEE,
} from "@utils/constants";
import { effectiveInterest, formatCurrency, formatMonthlyCost } from "@utils/format";
import Link from "next/link";
import { useEffect, useState } from "react";

const MARKS = [
	{ value: 12, label: "12" },
	{ value: 24, label: "24" },
	{ value: 36, label: "36" },
	{ value: 48, label: "48" },
	{ value: 60, label: "60" },
	{ value: 72, label: "72" },
];

const Calcuator = ({ price = 499000 }: any) => {
	const minCashDeposit = price * 0.2;
	const maxCashDeposit = price * 0.5;
	const [restAmount, setRestAmount] = useState(DEFAULT_SALVAGE_AMOUNT);
	const [cashDeposit, setCashDeposit] = useState(DEFAULT_CASH_DEPOSIT);
	const [months, setMonths] = useState(DEFAULT_MONTHS);

	const REST_AMOUNT_MARKS = [
		{ value: 0, label: formatCurrency(0) },
		{ value: 10, label: formatCurrency(price * 0.1) },
		{ value: 20, label: formatCurrency(price * 0.2) },
		{ value: 30, label: formatCurrency(price * 0.3) },
		{ value: 40, label: formatCurrency(price * 0.4) },
		{ value: 50, label: formatCurrency(price * 0.5) },
	];

	useEffect(() => {
		if (months > 36) setRestAmount(0);
	}, [months]);

	// name, rate, minYears, maxYears, cashDeposit, invoiceFee, setupFee, registrationFee
	return (
		<div className="flex flex-col gap-4">
			{/* <div>
					<p className="mb-0">Kontantinsats</p>
					<p className="mb-0">{formatCurrency(cashDeposit)}</p>
					<Slider
						size="lg"
						step={10}
						min={minCashDeposit}
						max={maxCashDeposit}
						value={cashDeposit}
						onChange={setCashDeposit}
					/>
				</div>
				<div>
					<p className="mb-0">Lånetid</p>
					<p className="mb-0">{months} månader</p>
					<Slider
						size="lg"
						label={(val) => MARKS.find((mark) => mark.value === val).label}
						value={months}
						onChange={setMonths}
						min={12}
						max={72}
						step={12}
						marks={MARKS}
						styles={{ markLabel: { display: "none" } }}
					/>
				</div>
				<div>
					<p className="mb-0">Restvärde</p>
					<p className="mb-0">{formatCurrency(price * (restAmount / 100))}</p>
					<Slider
						size="lg"
						label={(val) => REST_AMOUNT_MARKS.find((mark) => mark.value === val).label}
						value={restAmount}
						onChange={setRestAmount}
						min={0}
						max={50}
						step={10}
						marks={REST_AMOUNT_MARKS}
						styles={{ markLabel: { display: "none" } }}
					/>
				</div> */}
			<div className="flex flex-col gap-1">
				<div className="flex justify-between">
					<p className="mb-0">Kontantinsats ({cashDeposit}%)</p>
					<p className="mb-0">{formatCurrency(price * (cashDeposit / 100))}</p>
				</div>
				<div className="flex justify-between">
					<p className="mb-0">Avbetalningstid</p>
					<p className="mb-0">{months} månader</p>
				</div>
				<div className="flex justify-between">
					<p className="mb-0">Restvärde (55%)</p>
					<p className="mb-0">{formatCurrency(price * (restAmount / 100))}</p>
				</div>
				<div className="flex justify-between">
					<p className="mb-0">Ränta</p>
					<p className="mb-0">{DEFAULT_INTEREST_RATE.toFixed(2)} %</p>
				</div>
				<div className="flex justify-between">
					<p className="mb-0">Effektiv ränta</p>
					<p className="mb-0">{effectiveInterest(price, months, DEFAULT_INTEREST_RATE, cashDeposit, restAmount)} %</p>
				</div>
				<div className="flex justify-between">
					<p className="mb-0">Aviavgift</p>
					<p className="mb-0">{formatCurrency(DEFAULT_INVOICE_FEE)}</p>
				</div>
				<div className="flex justify-between">
					<p className="mb-0">Uppläggningsavgift</p>
					<p className="mb-0">{formatCurrency(DEFAULT_SETUP_FEE)}</p>
				</div>
				<div className="flex justify-between font-semibold">
					<p className="mb-0">Månadskostnad</p>
					<p className="mb-0">{formatMonthlyCost(price, months, DEFAULT_INTEREST_RATE, cashDeposit, restAmount)}</p>
				</div>
			</div>
		</div>
	);
};

export default Calcuator;
